import { useI18n } from 'vue-i18n'
import { LangType } from '@/i18n/index'

export function useChangeLangHooks() {
  const { locale } = useI18n()

  const changeLang = (lang: LangType) => {
    locale.value = lang
  }

  return {
    changeLang
  }
}
